import { defineAction } from '~/prix'
import actionJson from './communityGardenDocumentDelete.action.json' with { type: 'json' }
import { z } from 'zod'
import communityGardenDocumentObject from '../communityGardenDocumentObject'

const definition = defineAction({
  ...actionJson,
  input: z.object({ id: communityGardenDocumentObject.shape.id }),
  output: z.object({}),
})

export default definition
